var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnAddBtnGray = function SvgIcnAddBtnGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/Solid/add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.0002C12.4183 16.0002 16 12.4185 16 8.00018C16 3.58191 12.4183 0.000183105 8 0.000183105C3.58172 0.000183105 0 3.58191 0 8.00018C0 12.4185 3.58172 16.0002 8 16.0002ZM7.25 12.0002V8.75019H4C3.58579 8.75019 3.25 8.4144 3.25 8.00018C3.25 7.58597 3.58579 7.25019 4 7.25019L7.25 7.25018V4.00018C7.25 3.58597 7.58579 3.25018 8 3.25018C8.41421 3.25018 8.75 3.58597 8.75 4.00018V7.25018L12 7.25018C12.4142 7.25018 12.75 7.58597 12.75 8.00019C12.75 8.4144 12.4142 8.75018 12 8.75018L8.75 8.75019V12.0002C8.75 12.4144 8.41421 12.7502 8 12.7502C7.58579 12.7502 7.25 12.4144 7.25 12.0002Z",
    fill: "#7E8185"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAddBtnGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_add_btn_gray.42d3b85f.svg";
export { ForwardRef as ReactComponent };